import React from 'react';
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image
} from '@react-pdf/renderer';
// @ts-ignore
const logoCentralis = require('../../assets/logo/logo-centralis-gris.png');
// @ts-ignore
const bandeauCentralis = require('../../assets/logo/bandeau-centralis.png');

const styles = StyleSheet.create({
  page: {
    padding: 0,
    fontSize: 12,
    fontFamily: 'Helvetica',
    backgroundColor: '#FFFDFC'
  },
  bandeau: {
    width: '100%'
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 24,
    paddingBottom: 16
  },
  logo: {
    width: 100,
    marginRight: 16
  },
  userInfo: {
    fontSize: 14,
    fontWeight: 'bold',
    textAlign: 'right'
  },
  dateInfo: {
    fontSize: 12,
    color: '#6B7280',
    textAlign: 'right',
    marginTop: 4
  },
  titleSection: {
    backgroundColor: '#484848',
    padding: 16,
    marginHorizontal: 24,
    marginTop: 8,
    marginBottom: 16,
    borderRadius: 8
  },
  projectTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#FFFDFC',
    marginBottom: 4
  },
  projectSubtitle: {
    fontSize: 14,
    color: '#FFFDFC'
  },
  infoSection: {
    padding: 16,
    marginHorizontal: 24,
    marginBottom: 16,
    backgroundColor: '#F9FAFB',
    borderRadius: 8,
    borderWidth: 1,
    borderColor: '#E5E7EB'
  },
  infoRow: {
    flexDirection: 'row',
    marginBottom: 8
  },
  infoLabel: {
    fontWeight: 'bold',
    width: '40%',
    fontSize: 11
  },
  infoValue: {
    flex: 1,
    fontSize: 11
  },
  sectionTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    backgroundColor: 'rgba(215, 217, 217, 0.25)',
    padding: 12,
    marginHorizontal: 24,
    marginTop: 16,
    marginBottom: 8,
    borderRadius: 8
  },
  sectionContent: {
    marginHorizontal: 24,
    marginBottom: 16,
    padding: 12,
    backgroundColor: '#FFFDFC',
    borderRadius: 8,
    borderWidth: 1,
    borderColor: '#E5E7EB'
  },
  fieldLabel: {
    fontSize: 11,
    fontWeight: 'bold',
    marginBottom: 4
  },
  fieldValue: {
    fontSize: 11,
    marginBottom: 12,
    lineHeight: 1.4
  },
  table: {
    marginTop: 12
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#E5E7EB',
    minHeight: 24,
    alignItems: 'center'
  },
  tableHeader: {
    backgroundColor: 'rgba(215, 217, 217, 0.25)',
    fontWeight: 'bold'
  },
  tableCell: {
    flex: 1,
    fontSize: 10,
    padding: 6
  },
  tableCellNarrow: {
    width: 60,
    fontSize: 10,
    padding: 6
  },
  tableCellWide: {
    flex: 2,
    fontSize: 10,
    padding: 6
  },
  tableCellRight: {
    flex: 1,
    fontSize: 10,
    padding: 6,
    textAlign: 'right'
  },
  totalSection: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginTop: 12,
    paddingTop: 8,
    paddingRight: 6,
    borderTopWidth: 2,
    borderTopColor: '#E5E7EB'
  },
  totalLabel: {
    fontSize: 12,
    fontWeight: 'bold',
    marginRight: 8
  },
  totalValue: {
    fontSize: 12,
    fontWeight: 'bold'
  },
  footer: {
    position: 'absolute',
    bottom: 30,
    left: 24,
    right: 24,
    fontSize: 10,
    color: '#6B7280',
    textAlign: 'center',
    paddingTop: 8,
    borderTopWidth: 1,
    borderTopColor: '#E5E7EB'
  },
  statusBadge: {
    marginVertical: 4,
    padding: 6,
    width: 120,
    textAlign: 'center',
    borderRadius: 20,
    fontSize: 10,
    fontWeight: 'bold'
  },
  sectionHeader: {
    backgroundColor: '#f3f4f6',
    padding: 8,
    marginBottom: 2,
    fontWeight: 'bold',
    fontSize: 12,
    borderRadius: 4
  },
  actionsCell: {
    width: 80,
    fontSize: 10,
    padding: 6,
    textAlign: 'center'
  },
  detailTitle: {
    fontSize: 14,
    fontWeight: 'bold',
    marginBottom: 10,
    marginTop: 10
  },
  totalArticles: {
    fontSize: 12,
    fontWeight: 'bold',
    textAlign: 'right',
    marginTop: 10,
    marginRight: 10
  }
});

// Fonction pour obtenir les couleurs selon le statut
const getStatusStyle = (status: string) => {
  switch (status?.toLowerCase()) {
    case 'accepté':
      return { color: '#00A708', backgroundColor: 'rgba(0, 167, 8, 0.1)' };
    case 'refusé':
      return { color: '#D90E0E', backgroundColor: 'rgba(217, 14, 14, 0.1)' };
    case 'brouillon':
      return { color: '#6B7280', backgroundColor: 'rgba(107, 114, 128, 0.1)' };
    case 'en consultation':
      return { color: '#0486FF', backgroundColor: 'rgba(4, 134, 255, 0.1)' };
    case 'en attente':
      return { color: '#F4751B', backgroundColor: 'rgba(244, 117, 27, 0.1)' };
    case 'a valider':
      return { color: '#F4751B', backgroundColor: 'rgba(244, 117, 27, 0.1)' };
    default:
      return { color: '#6B7280', backgroundColor: 'rgba(107, 114, 128, 0.1)' };
  }
};

// Fonction pour calculer le nombre total d'articles
const countTotalArticles = (sections: any[]) => {
  if (!sections || !Array.isArray(sections)) return 0;
  return sections.reduce((count, section) => count + (section.articles ? section.articles.length : 0), 0);
};

// Composant principal PDF
const ConsultationPDF = ({ commande, user }: { commande: any; user: any }) => {
  const today = new Date().toLocaleDateString('fr-FR');
  const form = commande.formulaire || {};

  // Utiliser les sections à partir de form.sections d'abord, sinon utiliser commande.sections
  const sections = form.sections || commande.sections || [];

  // Extraire les articles de toutes les sections
  const articles = [];
  if (Array.isArray(sections)) {
    for (const section of sections) {
      if (section.articles && Array.isArray(section.articles)) {
        articles.push(...section.articles);
      }
    }
  }

  // Créer une structure par défaut si aucune section n'est disponible
  const sectionsToRender = sections.length > 0 ? sections : [{
    id: 'default',
    name: 'Articles',
    articles: articles
  }];

  const totalArticles = countTotalArticles(sectionsToRender);

  // S'assurer que status.nom existe avant de l'utiliser
  const statusStyle = getStatusStyle(commande.status?.nom || '');

  // Formatter la date de création
  const creationDate = commande.created_at
    ? new Date(commande.created_at).toLocaleDateString('fr-FR')
    : today;

  return (
    <Document>
      <Page size="A4" style={styles.page} wrap>
        {/* Bandeau Centralis */}
        <Image src={bandeauCentralis} style={styles.bandeau} />

        {/* En-tête avec informations utilisateur et date */}
        <View style={styles.header} wrap={false}>
          <View>
            <Text style={styles.userInfo}>{user?.nom || 'Utilisateur'}</Text>
            <Text style={styles.dateInfo}>Document généré le {today}</Text>
          </View>
        </View>

        {/* Informations générales */}
        <View style={styles.infoSection} wrap={false}>
          <View style={styles.infoRow}>
            <Text style={styles.infoLabel}>Consultation</Text>
          </View>
          <View style={styles.infoRow}>
            <Text style={styles.infoLabel}>
              N° {commande.numero || `MS-${commande.id}`} • MS
            </Text>
          </View>
          <View style={styles.infoRow}>
            <Text style={styles.infoLabel}>Lot technique:</Text>
            <Text style={styles.infoValue}>{commande.lot_technique?.nom || '-'}</Text>
          </View>
          <View style={styles.infoRow}>
            <Text style={styles.infoLabel}>Organisme:</Text>
            <Text style={styles.infoValue}>{commande.organisme_nom || '-'}</Text>
          </View>
          <View style={styles.infoRow}>
            <Text style={styles.infoLabel}>Date de création:</Text>
            <Text style={styles.infoValue}>{creationDate}</Text>
          </View>
          <View style={styles.infoRow}>
            <Text style={styles.infoLabel}>Statut:</Text>
            <View style={[styles.statusBadge, { backgroundColor: statusStyle.backgroundColor }]}>
              <Text style={{ color: statusStyle.color }}>{commande.status?.nom || 'Brouillon'}</Text>
            </View>
          </View>
        </View>

        {/* Section Descriptif Administratif */}
        <Text style={styles.sectionTitle}>Descriptif Administratif</Text>
        <View style={styles.sectionContent} wrap={false}>
          <View>
            <Text style={styles.fieldLabel}>Nom de l'opération</Text>
            <Text style={styles.fieldValue}>{form.nomOperation || commande.nom || '-'}</Text>
          </View>

          <View>
            <Text style={styles.fieldLabel}>Référence interne</Text>
            <Text style={styles.fieldValue}>{form.referenceInterne || commande.reference || '-'}</Text>
          </View>

          <View>
            <Text style={styles.fieldLabel}>Adresse</Text>
            <Text style={styles.fieldValue}>
              {form.adresse || commande.adresse ? `${form.adresse || commande.adresse}, ${form.codePostal || commande.code_postal || ''} ${form.ville || commande.ville || ''}` : '-'}
            </Text>
          </View>

          <View>
            <Text style={styles.fieldLabel}>Coordonnées maîtrise</Text>
            <Text style={styles.fieldValue}>
              {form.coordonneesMaitrise || commande.coordonnees_maitrise || '-'}
            </Text>
          </View>

          <View>
            <Text style={styles.fieldLabel}>Coordonnées maîtrise d'ouvrage</Text>

            <Text style={styles.fieldValue}>
              {form.coordonneesMaitriseDOuvrage || commande.coordonnees_maitrise_ouvrage || '-'}
            </Text>
          </View>
          {(commande.visite) && (
            <View>
              <Text style={styles.fieldLabel}>Conditions de visite</Text>
              <Text style={styles.fieldValue}>{form.conditionVisite || commande.conditionVisite || '-'}</Text>
            </View>
          )}
          <View>
            <Text style={styles.fieldLabel}>Dates</Text>
            <Text style={styles.fieldValue}>
              {`Délai de consultation: ${form.delaisConsultation || commande.delais || '-'} jours`}
            </Text>
            <Text style={styles.fieldValue}>
              {`Délai fin d'opération: ${form.delaisFinOperation || '-'} jours`}
            </Text>
            {form.dateDebutOperation && (
              <Text style={styles.fieldValue}>
                {`Date de début d'opération: ${form.dateDebutOperation ? new Date(form.dateDebutOperation).toLocaleDateString('fr-FR') : '-'}`}
              </Text>
            )}
          </View>


        </View>

        {/* Section Descriptif Technique - Groupée dans un View pour éviter la coupure */}
        <View wrap={false} break>
          <Text style={styles.sectionTitle}>Descriptif Technique</Text>
          <View style={styles.sectionContent}>
            <View>
              <Text style={styles.fieldLabel}>Définition du besoin</Text>
              <Text style={styles.fieldValue}>{form.besoin || commande.besoin || '-'}</Text>
            </View>
          </View>
        </View>

        {/* Section Descriptif Financier - Ajout d'un saut de page */}
        <View wrap={false} break>
          <Text style={styles.sectionTitle}>Descriptif Financier</Text>
          <View style={styles.sectionContent}>
            <Text style={styles.detailTitle}>Détail du Prix Global et Forfaitaire (DPGF):</Text>

            {/* Boucle sur chaque section */}
            {sectionsToRender.map((section, sectionIndex) => (
              <View key={`section-${sectionIndex}`} wrap={sectionIndex === 0} break={sectionIndex !== 0}>
                {/* Titre de la section */}
                <View style={styles.sectionHeader}>
                  <Text>{section.name || section.nom || `Section ${sectionIndex + 1}`}</Text>
                </View>

                {/* Entêtes du tableau */}
                <View style={[styles.tableRow, styles.tableHeader]}>
                  <Text style={styles.tableCellNarrow}>N° article</Text>
                  <Text style={styles.tableCell}>Nom de l'article</Text>
                  <Text style={styles.tableCellNarrow}>Unité</Text>
                </View>

                {/* Articles de la section avec pagination améliorée */}
                {section.articles && section.articles.length > 0 ? (
                  // Diviser les articles en groupes de 10 pour éviter les problèmes avec des sections trop grandes
                  Array(Math.ceil(section.articles.length / 10)).fill(0).map((_, groupIndex) => (
                    <View key={`group-${section.id}-${groupIndex}`} wrap={false} break={groupIndex !== 0}>
                      {section.articles.slice(groupIndex * 10, (groupIndex + 1) * 10).map((article: any, index: number) => (
                        <View key={`article-${section.id}-${groupIndex * 10 + index}`} style={styles.tableRow}>
                          <Text style={styles.tableCellNarrow}>{article.code || (groupIndex * 10 + index + 1)}</Text>
                          <Text style={styles.tableCell}>{article.nom || '-'}</Text>
                          <Text style={styles.tableCellNarrow}>{article.unite || '-'}</Text>
                        </View>
                      ))}
                    </View>
                  ))
                ) : (
                  <View style={styles.tableRow}>
                    <Text style={{ ...styles.tableCell, textAlign: 'center' }}>Aucun article</Text>
                  </View>
                )}
              </View>
            ))}

            {/* Total des articles */}
            <Text style={styles.totalArticles}>Total {totalArticles} articles</Text>
          </View>
        </View>

        {/* Pied de page */}
        <Text style={styles.footer} fixed render={({ pageNumber, totalPages }) => (
          `Document généré par Centralis • ${today} • ${user?.email || ''} • Page ${pageNumber}/${totalPages}`
        )} />
      </Page>
    </Document>
  );
};

export default ConsultationPDF;